import {
  GET_DEAL_DATA, GET_DEAL_DATA_BY_FILE, GET_DEAL_TASK_ATTACHMENT_TEXT_DATA, GET_DEAL_FILE_TEXT_DATA,
  SAVE_DEAL_DATA, SAVE_DEAL_STATUS, SAVE_DEAL_TAB_SETTINGS, VIEW_DEAL_FILE, RESET_DEAL_DATA, RESET_NEW_DEAL_ID,
  RESET_DEAL_FILE_ANALYZED, RESET_DEAL_FILE_CHAT_RESPONSE_TEXT,
} from '../../constants/system/actions';

const getDealData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_DEAL_DATA, payload, resolve, reject,
});

const getDealDataByFile: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_DEAL_DATA_BY_FILE, payload, resolve, reject,
});

const getDealTaskAttachmentTextData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_DEAL_TASK_ATTACHMENT_TEXT_DATA, payload, resolve, reject,
});

const getDealFileTextData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_DEAL_FILE_TEXT_DATA, payload, resolve, reject,
});

const saveDealData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_DEAL_DATA, payload, resolve, reject,
});

const saveDealStatus: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_DEAL_STATUS, payload, resolve, reject,
});

const viewDealFile: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: VIEW_DEAL_FILE, payload, resolve, reject,
});

const resetDealData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_DEAL_DATA, payload,
});

const resetNewDealId: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_NEW_DEAL_ID, payload,
});

const resetDealFileAnalyzed: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_DEAL_FILE_ANALYZED, payload,
});

const resetDealFileChatResponseText: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_DEAL_FILE_CHAT_RESPONSE_TEXT, payload,
});

const saveDealTabSettings: Function = (payload?: ActionPayload): ReduxAction => ({
  type: SAVE_DEAL_TAB_SETTINGS, payload,
});

export {
  getDealData,
  getDealDataByFile,
  getDealTaskAttachmentTextData,
  getDealFileTextData,
  saveDealData,
  saveDealStatus,
  viewDealFile,
  resetDealData,
  resetNewDealId,
  resetDealFileAnalyzed,
  resetDealFileChatResponseText,
  saveDealTabSettings,
};
